var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C2FAE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 10.375H11.2917C10.5093 10.375 9.875 11.0093 9.875 11.7917V18.1667C9.875 18.9491 10.5093 19.5833 11.2917 19.5833H17.6667C18.4491 19.5833 19.0833 18.9491 19.0833 18.1667V11.7917C19.0833 11.0093 18.4491 10.375 17.6667 10.375Z",
    stroke: "#1F243B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03906 14.6263H6.33073C5.95501 14.6263 5.59467 14.477 5.32899 14.2114C5.06332 13.9457 4.91406 13.5854 4.91406 13.2096V6.83464C4.91406 6.45891 5.06332 6.09858 5.32899 5.8329C5.59467 5.56722 5.95501 5.41797 6.33073 5.41797H12.7057C13.0815 5.41797 13.4418 5.56722 13.7075 5.8329C13.9731 6.09858 14.1224 6.45891 14.1224 6.83464V7.54297",
    stroke: "#1F243B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.fce5eb934968ed9ad292d8d0cbb46030.svg";
export { ForwardRef as ReactComponent };